<script setup lang="ts">
defineOptions({
    prefetch: (to) => {
        // For the auth dialog.
        if (to.query.auth && !to.meta.hideOverlayContainer) useSignupPromotions({ query: to.query, server: true, lazy: false })
    },
})

const route = useRoute()
const { refresh, isLoggedIn } = useUserInfo()

function focusRefetch() {
    if (!isLoggedIn.value) return

    refresh()
}

useRefetchThrottle({
    refetchInput: () => focusRefetch(),
    useFocus: true,
    key: 'app-layout'
})
</script>

<template>
    <UIApp>
        <NuxtLayout>
            <NuxtPage />

            <LazyOverlayContainer v-if="!route.meta.hideOverlayContainer" />

            <UIIntercomContainer v-if="!route.meta.hideIntercom" />
        </NuxtLayout>
    </UIApp>
</template>
